<script>

export default {
  name: 'IpHistoryModal',
  props:[
    "network"
  ],
  data() {
    return {
        list:{}
    };
  },
  watch:{
    network(subsId){
        this.getDetail(subsId)
    }
  },
  methods: {
    async getDetail(subsId){
      await this.$http.get(`/members/getIpHistory/${subsId}`)
              .then(response => {
                  this.list = response.data
                })
              .catch(error => error)
    },
    close(){
      this.$bvModal.hide('ip_modal')
    }
  },
};
</script>

<template>
  <b-modal id="ip_modal" title="İp Geçmişi"  no-close-on-backdrop hide-footer>
      
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Eski İp</th>
                            <th>Statik İp</th>
                            <th>Değiştiren</th>
                            <th>Tarih</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(lst,i) in list" :key="i">
                            <td>{{ lst.old_value }}</td>
                            <td>{{ lst.ip_type ==1 ? 'Statik' : 'Lokal' }}</td>
                            <td>{{ lst.name }}</td>
                            <td>{{ lst.created_at }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
            <b-button variant="light" type="button" @click="close()">Kapat</b-button>
        </div>
    </b-modal>
</template>